import React, { useState } from "react";
import Hero from "../components/Hero";
import { Box } from "@mui/material";
import Services from "../components/Services";
import StaffList from "../components/StaffList";
import MoreService from "../components/MoreService";
import PriseList from "../components/PriseList";
import CustomerReview from "../components/CustomerReview";
import Contact from "../components/Contact";
import BookingModal from "../components/BookingModal";

const ClearnPage: React.FC = () => {
  const [openBooking, setOpenBooking] = useState(false);
  const [serviceNameSelected, setServiceNameSelected] = useState("");
  const handleCloseBooking = () => setOpenBooking(false);
  const handleOpenBooking = (serviceName: string) => {
    setServiceNameSelected(serviceName);
    setOpenBooking(true);
  };
  return (
    <Box>
      <Hero handleOpenBooking={handleOpenBooking} />
      <Services handleOpenBooking={handleOpenBooking} />
      <StaffList />
      <MoreService handleOpenBooking={handleOpenBooking} />
      <PriseList />
      <CustomerReview />
      <Contact />
      <BookingModal
        open={openBooking}
        handleClose={handleCloseBooking}
        serviceName={serviceNameSelected}
      />
    </Box>
  );
};

export default ClearnPage;
